// Bulk actions are N individual GitHub mutations (no batch API), so run them
// with bounded concurrency to stay clear of the secondary rate limit, and
// report one aggregate result rather than N toasts. Each per-item fn reuses
// the normal single-issue mutation (optimistic patch + rollback) in silent mode.
export async function runBulk<T>(
  items: T[],
  fn: (item: T) => Promise<unknown>,
  concurrency = 4,
): Promise<{ ok: number; failed: number }> {
  let ok = 0
  let failed = 0
  let next = 0

  async function worker() {
    while (next < items.length) {
      const item = items[next++]!
      try {
        await fn(item)
        ok++
      } catch {
        failed++
      }
    }
  }

  await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, worker))
  return { ok, failed }
}
